import { createStore } from "vuex";
import { config } from "vuex-module-decorators";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import CustomerModule from "@/store/modules/Customer/CustomerModule.js";
import ActivityTypeModule from "@/store/modules/Customer/ActivityTypeModel.js";
import LanguageModule from "@/store/modules/AuthLang/LanguageModule.js";
import AuthModule from "@/store/modules/AuthLang/AuthModule.js";
import UsersModule from "@/store/modules/Users/UsersModule.js";
import LocationModule from "@/store/modules/Customer/LocationModule.js";
import ProjectModule from "@/store/modules/Customer/ProjectModule.js";
import DepartmentModule from "@/store/modules/Audit/DepartmentModule.js";
import UserRoleModule from "@/store/modules/Users/UserRoleModule.js";
import CategoryModule from "@/store/modules/Audit/CategoryModule.js";
import CompanyModule from "@/store/modules/Company/CompanyModule.js";
import QuestionModule from "@/store/modules/Audit/QuestionModule.js";
import CheckListModule from "@/store/modules/Audit/CheckListModule.js";
import AuditPlanningModule from "@/store/modules/Audit/AuditPlanningModule.js";
import AnswersTempalteModule from "@/store/modules/Audit/AnswersTempalteModule.js";
import DashboardModule from "@/store/modules/Dashboard/DashboardModule.js";
import ActionModule from "@/store/modules/Audit/ActionModule.js";
import AuditReportModule from "@/store/modules/Audit/AuditReportModule.js";

import AdminTemplateCheckListModule from "@/store/modules/Templates/AdminTemplateCheckListModule.js";
import AdminTemplateAnswersTempalteModule from "@/store/modules/Templates/AdminTemplateAnswersTempalteModule.js";
import AdminTemplateDepartmentModule from "@/store/modules/Templates/AdminTemplateDepartmentModule.js";
import AdminTemplateQuestionModule from "@/store/modules/Templates/AdminTemplateQuestionModule.js";
import AdminTemplateCategoryModule from "@/store/modules/Templates/AdminTemplateCategoryModule.js";

config.rawError = true;

const ls = new SecureLS({ isCompression: false });

const persistedStateOptions = {
  key: "User",
  paths: ["AuthModule.User"],
  storage: {
    getItem: (key) => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: (key) => ls.remove(key),
  },
};

const store = createStore({
  state: {
    platform: false,
  },
  modules: {
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    CustomerModule,
    ActivityTypeModule,
    LanguageModule,
    AuthModule,
    UsersModule,
    LocationModule,
    ProjectModule,
    DepartmentModule,
    UserRoleModule,
    CategoryModule,
    CompanyModule,
    QuestionModule,
    CheckListModule,
    AuditPlanningModule,
    AnswersTempalteModule,
    DashboardModule,
    ActionModule,
    AdminTemplateCheckListModule,
    AdminTemplateAnswersTempalteModule,
    AdminTemplateDepartmentModule,
    AdminTemplateQuestionModule,
    AdminTemplateCategoryModule,
    AuditReportModule,
  },

  plugins: [createPersistedState(persistedStateOptions)],
});

export default store;
